module.exports = __webpack_public_path__ + "static/profile_@2x-fa7511dd0a9606057de0420fe2d7b79f.jpg";